import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import ACPackagedUnitDetail from '../../components/ac_packaged_unit/ACPackagedUnitDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import { createACPackagedUnit } from '../../redux/ac_packaged_unit/ac_packaged_unit_actions';

class ACPackagedUnitCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  onSaveHandler() {
    const newAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.createAC(newAC);
  }

  render() {
    const { isCreating, errorMessage, createAC, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create a/c packaged unit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ACPackagedUnitDetail
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-package-unit-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.packagedUnit.errorMessage,
  isCreating: state.ac.packagedUnit.isCreating,
});

const mapDispatchToProps = dispatch => ({
  createAC: ac =>
    defaultRejectHandler(
      dispatch(
        createACPackagedUnit(
          ac.name,
          ac.type,
          ac.brand_id,
          ac.SEER,
          toCoolingCap(ac.cooling_capacity, ac.unit),
          ac.unit,
          ac.power_required,
          ac.description,
          ac.image,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACPackagedUnitCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_packaged_unit/ACPackagedUnitCreateModal.js